// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Display_wrapper__28att","header":"Display_header__2zACX","body":"Display_body__en77T","footer":"Display_footer__kFQn0"};